import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import "./PaginaInicio.css";
import "./ZoomPage.css";
import Cabecera from "../Others/Cabecera";
import PiePagina from "../Others/PiePagina";
import BotonBarraInferior from "../Others/BotonBarraInferior";
import BarraSuperior from "../Others/BarraSuperior";
import BarraInferior from "../Others/BarraInferior";
import CourseRecordingsPanel from "../Others/CourseRecordingsPanel";
import { useData } from "./DataContext";
import { getLinkTeacher } from "./constants";
import { normalizarLinksZoom } from "../Others/zoomCourseUtils";

const barra_inferior = (
  <BarraInferior
    contenido={
      <>
        <BotonBarraInferior imagenSrc={require("../Assets/tablon.png")} texto="Foro de Discusión" redireccion="t-pagina-tablon" />
        <BotonBarraInferior imagenSrc={require("../Assets/contenido.png")} texto="Contenido" redireccion="t-pagina-content" />
        <BotonBarraInferior imagenSrc={require("../Assets/tareas.png")} texto="Ejercicios" redireccion="t-pagina-tareas" />
        <BotonBarraInferior imagenSrc={require("../Assets/tareas.png")} texto="Evaluación Diagnostica" redireccion="t-pagina-evaluacion" />
        <BotonBarraInferior imagenSrc={require("../Assets/tareas.png")} texto="Evaluación Final" redireccion="t-pagina-evaluacionfi" />
        <BotonBarraInferior imagenSrc={require("../Assets/zoom.png")} texto="Zoom" redireccion="t-pagina-zoom" />
      </>
    }
  />
);

const TeacherZoom = () => {
  const { data, dataClase } = useData();
  const [links, setLinks] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  const barra_superior = (
    <BarraSuperior
      texto_cabecera={dataClase?.nombre_clase || "Zoom del curso"}
      redireccion="teacher-home"
      profile_redireccion="t-profile-page"
    />
  );

  const fetchLinks = useCallback(async () => {
    if (!data?.matricula || !dataClase?.matricula_clase) {
      setLinks([]);
      setError("No fue posible identificar al maestro o la materia seleccionada.");
      setCargando(false);
      return;
    }

    setCargando(true);
    setError("");

    try {
      const response = await axios.get(getLinkTeacher, {
        params: { matricula_maestro: data.matricula },
      });

      const linksMaestro = normalizarLinksZoom(response.data);
      const matriculaCurso = String(dataClase.matricula_clase);
      setLinks(
        linksMaestro.filter(
          (link) => String(link?.matricula_clase || "") === matriculaCurso,
        ),
      );
    } catch (requestError) {
      console.error("Error al obtener los enlaces del maestro:", requestError);
      setLinks([]);
      setError("No se pudieron consultar las reuniones de Zoom de esta materia.");
    } finally {
      setCargando(false);
    }
  }, [data?.matricula, dataClase?.matricula_clase]);

  useEffect(() => {
    fetchLinks();
  }, [fetchLinks]);

  const linksOrdenados = useMemo(
    () =>
      [...links].sort((a, b) =>
        `${a.fecha || ""} ${a.hora || ""}`.localeCompare(
          `${b.fecha || ""} ${b.hora || ""}`,
        ),
      ),
    [links],
  );

  return (
    <div className="contenedor-pagina">
      <Cabecera contenidosuperior={barra_superior} contenidoInferior={barra_inferior} />

      <main className="student-zoom-page">
        <section className="student-zoom-panel">
          <div className="student-zoom-header">
            <div>
              <span className="student-zoom-eyebrow">Sesiones en vivo</span>
              <h1>Zoom · {dataClase?.nombre_clase || "Curso"}</h1>
              <p>Consulta las ligas de Zoom registradas para esta materia.</p>
            </div>

            {!cargando && !error && linksOrdenados.length > 0 && (
              <span className="student-zoom-summary">
                {linksOrdenados.length}{" "}
                {linksOrdenados.length === 1 ? "reunión registrada" : "reuniones registradas"}
              </span>
            )}
          </div>

          {cargando && (
            <div className="student-zoom-state" role="status">
              <span className="student-zoom-spinner" aria-hidden="true" />
              <strong>Consultando Zoom...</strong>
              <p>Buscando las reuniones registradas para este curso.</p>
            </div>
          )}

          {!cargando && error && (
            <div className="student-zoom-state student-zoom-state-error" role="alert">
              <span className="student-zoom-state-icon" aria-hidden="true">!</span>
              <strong>No pudimos consultar Zoom</strong>
              <p>{error}</p>
              <button type="button" onClick={fetchLinks}>Intentar nuevamente</button>
            </div>
          )}

          {!cargando && !error && linksOrdenados.length === 0 && (
            <div className="student-zoom-state">
              <span className="student-zoom-state-icon student-zoom-state-icon-empty" aria-hidden="true">0</span>
              <strong>Sin reuniones registradas</strong>
              <p>No existen ligas de Zoom registradas para esta materia.</p>
            </div>
          )}

          {!cargando && !error && linksOrdenados.length > 0 && (
            <div className="student-zoom-grid">
              {linksOrdenados.map((link, index) => (
                <article className="student-zoom-card" key={link.id_url || `${link.matricula_clase}-${index}`}>
                  <div className="student-zoom-card-top">
                    <span className="student-zoom-camera" aria-hidden="true">Z</span>
                    <div>
                      <h2>{link.nombre_clase || dataClase?.nombre_clase || "Clase"}</h2>
                      <span className="student-zoom-matricula">
                        {link.matricula_clase || dataClase?.matricula_clase}
                      </span>
                    </div>
                    <span className="student-zoom-status">Zoom</span>
                  </div>

                  <div className="student-zoom-details">
                    <div>
                      <span>Fecha</span>
                      <strong>{link.fecha || "Sin fecha"}</strong>
                    </div>
                    <div>
                      <span>Hora</span>
                      <strong>{link.hora || "Sin hora"}</strong>
                    </div>
                  </div>

                  <a
                    className={`student-zoom-open${link.url ? "" : " student-zoom-open-disabled"}`}
                    href={link.url || undefined}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-disabled={!link.url}
                  >
                    Entrar a la reunión
                  </a>
                </article>
              ))}
            </div>
          )}
        </section>

        <CourseRecordingsPanel
          mode="readonly"
          idClase={dataClase?.id_clase}
          accessToken={data?.access_token}
        />
      </main>

      <PiePagina imagenSrc={require("../Assets/piepagina.jpg")} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};

export default TeacherZoom;
